// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-width-select[data-v-4073f1b8]{width:100%;min-width:190px}.membership-airline-select[data-v-4073f1b8] {width:100%;min-width:190px;background:#fff;border-radius:50px}.membership-airline-select[data-v-4073f1b8]  .vs__dropdown-toggle{border:none!important;-webkit-box-shadow:none!important;box-shadow:none!important}.fixed-feedback[data-v-4073f1b8]{min-height:20px;line-height:20px}.card[data-v-4073f1b8]{-webkit-box-shadow:none;box-shadow:none}", ""]);
// Exports
module.exports = exports;
